import { Box } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import { ValidationCallout } from 'modules/integrations/components/SyncButton/Modals/ValidationsModal/ValidationCallout'
import { Validation } from 'modules/integrations/hooks/SyncContext/validations'

type ValidationsModalProps = {
  onClose: () => void
  validations: Validation[]
}

export function ValidationsModal({ onClose, validations }: ValidationsModalProps) {
  return (
    <Modal
      illustration="upload"
      title={i18n.t('compensations.integrations.validations_sidepanel_title', {
        integration_name: 'a3innuva',
      })}
      onClose={onClose}
    >
      <Box gap="s32" width="s600">
        {validations.map((validation, index) => (
          <ValidationCallout validation={validation} key={index} />
        ))}
      </Box>
    </Modal>
  )
}
